import { initLiveList } from '../../shared/liveList.js';

// One Zefix sweep, with the customers behind its counters (WOR-LI-G44).
//
// Nothing but the live list, like the log this hangs off: the page is the
// record of a run that is already over, so there is no decision to make here.
// Working a case happens in the manager (/zefix/faelle), and a row links there
// rather than carrying its own buttons.
//
// The path has to be read from the URL rather than hardcoded: this list lives
// under /zefix/laeufe/:id, so the run's own id is part of where its results
// come from.
export function initZefixLauf() {
  const region = document.getElementById('zefix-lauf-detail-list');
  if (!region) return;

  initLiveList({
    results: 'zefix-lauf-detail-list',
    path: window.location.pathname,
    forms: ['zefix-lauf-detail-filter']
  });
}
